import Pagination from 'components/Pagination'
import SearchIcon from 'components/icons/SearchIcon'
import React from 'react'
import { ConflictPara, StyleInput } from './Styles/style'
import { StyledTableSqare } from './TableStyle'

export default function ResolveConflict({
  conflictData,
  handlePageChange,
  handleSearch,
  conflictFilter,
  isLoading,
  columns,
}) {
  const flattenedData =
    conflictData?.length !== 0 &&
    conflictData?.result?.flatMap(item => {
      if (item.candidateDetails.length === 0) {
        return [
          {
            ...item,
            candidateDetail: null,
            candidateDetailIndex: 0,
          },
        ]
      } else {
        return item.candidateDetails.map((detail, index) => ({
          ...item,
          candidateDetail: detail,
          candidateDetailIndex: index,
        }))
      }
    })

  return (
    <>
      <ConflictPara>
        The conflict status here shows if
        <br /> eMail ID doesn’t match with the system data
      </ConflictPara>
      <ConflictPara font="600">
        Click on the status to approve candidate.
      </ConflictPara>
      <StyleInput
        width={'100%'}
        height={'50px'}
        placeholder={'Search By Keyword'}
        prefix={<SearchIcon />}
        value={conflictFilter.search}
        onChange={(e)=>handleSearch(e.target.value)}
      />

      <StyledTableSqare
        columns={columns}
        dataSource={flattenedData}
        pagination={false}
        className={'resolve-conflict-table'}
        loading={isLoading}
        bordered
        scroll={{
          x: '1400',
        }}
      />

      <Pagination
        totalPages={conflictData?.count}
        pageSize={10}
        current={conflictFilter.page + 1}
        onChange={handlePageChange}
      />
    </>
  )
}
